<ngb-pagination [collectionSize]="totalElements || 0"
                [(page)]="pageIndex"
                size="sm"
                [maxSize]="maxNumbersToDisplay"
                [pageSize]="elementsPerPage"
                (pageChange)="onPageIndexChange($event)">

  <ng-template ngbPaginationPrevious><bringoz-icon iconName="chevron-left"></bringoz-icon></ng-template>
  <ng-template ngbPaginationNext><bringoz-icon iconName="chevron-right"></bringoz-icon></ng-template>

</ngb-pagination>
